import type { ProofIndexEntry } from "./proofIndexEntry";

/** The PR's title as the Proof index lists it, else `repo#41`. */
export function proofRowTitle(
  proof: Pick<
    ProofIndexEntry,
    "pullRequest" | "prTitle" | "repository" | "prNumber"
  >,
): string {
  return proof.pullRequest?.title || proof.prTitle || proofRowReference(proof);
}

/** `acme/web` → `web`. */
export function proofRepoShort(
  proof: Pick<ProofIndexEntry, "repository">,
): string {
  return proof.repository.split("/")[1] ?? proof.repository;
}

/** `acme/web` #41 → `web#41`. */
export function proofRowReference(
  proof: Pick<ProofIndexEntry, "repository" | "prNumber">,
): string {
  return `${proofRepoShort(proof)}#${proof.prNumber}`;
}
